import { useContext } from 'react';

import { ShadowRootContainerRefContext } from '../components/ShadowRootContainer';

export function useShadowRootContainer(): HTMLElement | null {
  return useContext(ShadowRootContainerRefContext);
}
